import { ApiResult, request, safeRequest } from '@synergy/api';
import { Locale } from '@synergy/models';

import { Account } from '../models/account';
import { ConfigurationResponse } from './models/configuration-response';

export class ConfigApi {
    constructor(protected baseUrl: string) {}

    public getBaseState = (): Promise<ApiResult<ConfigurationResponse>> =>
        safeRequest(
            () => request.get(`${this.baseUrl}/`),
            response => response.data
        );

    public changeAccount = (accountId: number): Promise<ApiResult<Account>> =>
        safeRequest(
            () => request.post(`${this.baseUrl}/change-account/${accountId}`),
            response => response.data
        );

    public changeLocale = (locale: Locale): Promise<ApiResult<null>> =>
        safeRequest(
            () => request.post(`${this.baseUrl}/change-locale/${locale}`),
            () => null
        );
}
